export default {"src":"/evde-internet/_next/static/media/acceleration.70fefeab.svg","height":226,"width":226};